import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.fixCountryLanguageLinks()
  }

  fixCountryLanguageLinks() {
    const currentPath = window.location.pathname
    const currentLocale = document.querySelector('section[data-locale]')?.dataset.locale
    
    if (!currentLocale) return
    
    const currentPathMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})\//)
    if (!currentPathMatch || !currentPathMatch[1]) return
    
    const currentCountryLanguage = currentPathMatch[1]
    
    const blogContentDiv = document.querySelector('.blog-content')
    if (!blogContentDiv) return
    
    const links = blogContentDiv.querySelectorAll('a')
    
    links.forEach(link => {
      const href = link.getAttribute('href')
      
      const linkMatch = href?.match(/^https?:\/\/[^\/]+\/([a-z]{2}-[a-z]{2})\/(.+)$/)
      
      if (linkMatch && linkMatch[1] !== currentCountryLanguage) {
        const newHref = href.replace(`/${linkMatch[1]}/`, `/${currentCountryLanguage}/`)
        link.setAttribute('href', newHref)
      }
    })
  }
}
